import { useEffect } from "react";
import { Link, createFileRoute } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { useTranslation } from "react-i18next";
import { RequireAuth } from "@/components/RequireAuth";
import { AppShell } from "@/components/layout/AppShell";
import { LiquidationForm } from "@/components/payroll/LiquidationForm";
import { useActiveCompany } from "@/lib/company-context";

export const Route = createFileRoute(
  "/companies/$companyId/nomina/liquidaciones/new",
)({
  component: NewLiquidationPage,
});

function NewLiquidationPage() {
  return (
    <RequireAuth>
      <AppShell>
        <NewLiquidationContent />
      </AppShell>
    </RequireAuth>
  );
}

function NewLiquidationContent() {
  const { t } = useTranslation();
  const { companyId } = Route.useParams();
  const { setActiveCompanyId } = useActiveCompany();

  useEffect(() => {
    if (companyId) setActiveCompanyId(companyId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyId]);

  return (
    <div className="mx-auto flex max-w-4xl flex-col gap-6">
      <div>
        <Link
          to="/companies/$companyId/nomina/liquidaciones"
          params={{ companyId }}
          className="inline-flex items-center gap-1 text-xs text-muted-foreground hover:text-foreground"
        >
          <ArrowLeft className="h-3 w-3" />
          {t("liquidations.new.back")}
        </Link>
        <h1 className="mt-1 text-2xl font-semibold tracking-tight">
          {t("liquidations.new.title")}
        </h1>
        <p className="mt-1 text-sm text-muted-foreground">
          {t("liquidations.new.subtitle")}
        </p>
      </div>
      <LiquidationForm companyId={companyId} />
    </div>
  );
}
